const etapes = [
  {
    num: "1",
    icon: "ri-ruler-line",
    title: "Visite et mesures gratuites",
    desc: "Nous venons sur place à Strasbourg pour mesurer votre baie et évaluer les contraintes techniques. Vous choisissez le type de volet, le mode de commande et les options. Aucun frais, aucun engagement.",
  },
  {
    num: "2",
    icon: "ri-file-list-3-line",
    title: "Devis clair et détaillé",
    desc: "Vous recevez un devis transparent sous 24h : prix de la pose, matériel, main-d'œuvre, délais. Pas de surprise, pas de frais cachés. Vous validez quand vous êtes prêt.",
  },
  {
    num: "3",
    icon: "ri-tools-line",
    title: "Pose soignée + démonstration",
    desc: "Nos techniciens installent votre volet en respectant les normes et votre intérieur. Nettoyage, tests et démonstration de fonctionnement inclus. Vous repartez avec un volet neuf et opérationnel.",
  },
];

export default function CommentCaSePasse() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-3">
          Comment ça se passe
        </h2>
        <p className="text-brand-text text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Trois étapes simples pour votre nouveau volet roulant, de la première visite à la pose finale.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {etapes.map((etape) => (
            <div key={etape.num} className="text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-brand-cyan text-white text-xl font-bold mb-5">
                {etape.num}
              </div>
              <div className="w-10 h-10 mx-auto flex items-center justify-center mb-4">
                <i className={`${etape.icon} text-brand-blue text-2xl`}></i>
              </div>
              <h3 className="text-brand-blue text-lg font-bold mb-3">{etape.title}</h3>
              <p className="text-brand-text text-sm leading-relaxed max-w-sm mx-auto">{etape.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}